//使用<advanced-simple-uploader :beforeFileList="beforeRequirementFileDetail" :maxNum='1' isSource="https://gateway.yingxiong.com/file-api/api/file/fileChunkUpload" source="coop" ref="uploader"  @onSuccess="(file, fileList) => handleSuccess(file, fileList, 'requirementFileId')"  @onRemove="handleRemove($event,'requirementFileId')" @onDelete="handleRemove($event,'requirementFileId')"  style="min-width:660px; width:25vw"></advanced-simple-uploader>
//beforeFileList:需要回显的文件list               
//具体使用可参照cooperation
<template>
    <div class="pane">
        <simple-uploader ref="advancedSimpleUploader"  @onSuccess="handleSuccess" @onRemove="handleRemove" v-if="true" v-bind="$attrs" :beforeFileList='beforeFileList'></simple-uploader>
        <div class="beforePane" v-if="beforeFileList.length !== 0">
            已有文件：
            <ul>
                <li v-for="(item,index) of beforeFileList" :key="item.id" @click="rowClick(item)">
                    <span class="fileNameClass" :title="item.name">
                    <!-- <i class="uploader-file-icon" :icon="item.fileCategory"></i> -->
                    {{item.name}}
                    </span>
                    <i class="el-icon-close icon close-icon" @click.stop="handleDelete(index)"></i>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import SimpleUploader from '../../materialCenter/components/simpleUploader.vue'
export default {
    components:{SimpleUploader},
    props:{
        beforeFileList:{
            type:Array,
            default:()=>{
                return []
            }
        }
    },
    mixins:[],
    data() {
        return { 
        }
    },
    computed: {
      
    },
    created(){
        this.beforeFileList.map((item)=>{
            item.fileCategory = this.fileCategory(item.suffixType)
        })
    },

    methods:{
        rowClick(item){
            this.$emit('rowClick',item)
        },
        fileCategory (str) {
            const extension = str
            let type = 'unknown'
            const typeMap =  {
            image: ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'],
            video: ['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'],
            audio: ['mp3', 'wav', 'wma', 'ogg', 'aac', 'flac'],
            document: ['doc', 'txt', 'docx', 'pages', 'epub', 'pdf', 'numbers', 'csv', 'xls', 'xlsx', 'keynote', 'ppt', 'pptx']
            }
            Object.keys(typeMap).forEach((_type) => {
            const extensions = typeMap[_type]
            if (extensions.indexOf(extension) > -1) {
                type = _type
            }
            })
            return type
        },
        // 上传成功
        handleSuccess(file, fileList) {
            
            this.$emit('onSuccess',file,this.updateFileList(fileList))
        },
        updateFileList(fileList){
            let resultFileList = []
            this.beforeFileList.forEach((item)=>{
                resultFileList.push(item);
            });
            fileList.map((item,index)=>{
                resultFileList.push(item)
            })
            return resultFileList;
        },

        // 删除已上传
        handleRemove(fileList) {
            let resultFileList = this.updateFileList(fileList)
            this.$emit('onRemove', resultFileList)
        },
        handleDelete(index){
            
            this.beforeFileList.splice(index,1)
            let resultFileList = this.updateFileList(this.$refs.advancedSimpleUploader.$refs.uploader.fileList)
            this.$emit('onDelete',resultFileList)
        }
    }
}
</script>

<style lang="scss" scoped>
.pane{
    .line{
        margin: 32px 0 32px;
        height: 1px;
        background: #EEEEEE;
    }
    .beforePane{
        ul{
            list-style-type: none;
            padding-inline-start: 35px;
            margin-block-start: 0;
            li{
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
                align-items: center;
                cursor: pointer;
                .fileNameClass{
                    display: block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 340px;
                }

                .uploader-file{
                    flex-grow: 1;
                }
                .icon{
                    flex-grow: 0;
                    cursor: pointer;
                }
            
                .close-icon{
                    display: block;
                }
                
            }

        }
        
        
    }
}
   

</style>